// ═══ 업무별 기록 — 입금 '참고 업체로 일괄 연결' 미리보기 모달 (DESIGN §8.2·§8.4-3) ═══
// POST /work-records/link-hints
//   {jobKind, dryRun:true} → {success, linkable, amount, byUnit:[{unitId,unitName,count,amount}], unresolved:{noLinkedItems,multiUnit,ineligible}}
//   {jobKind, expect:{linkable, amount}} → {success, updated} · 409 PREVIEW_CHANGED {preview} = 새 미리보기로 다시 확인
// 사용자가 미리보기를 보고 [연결] 을 눌러야 실행된다 (결정 2 — 자동 배정 아님).
//
// props: jobKind · showToast · onClose · onDone
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var fmt = function (n) { return (parseInt(n, 10) || 0).toLocaleString(); };
var num = function (n) { return parseInt(n, 10) || 0; };
var post = function (url, body) {
  return authFetch(API + url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
    .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, data: d || {} }; }); });
};
var overlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 16 };
var th = { padding: '8px 6px', fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap', textAlign: 'left', color: '#64748b', background: '#f8fafc' };
var td = { padding: '6px', fontSize: 12, whiteSpace: 'nowrap', borderTop: '1px solid #f1f5f9', verticalAlign: 'top' };
var hintSt = { margin: '0 0 10px', fontSize: 12.5, color: '#64748b', lineHeight: 1.6 };
var errBox = function (err) {
  return err ? <div style={{ padding: 12, background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, color: '#b91c1c', fontSize: 12.5, marginBottom: 10 }}>{err}</div> : null;
};
var UNRESOLVED_LABEL = { noLinkedItems: '참고 이름에 연결된 건이 아직 없음', multiUnit: '참고 이름이 여러 업체에 연결됨', ineligible: '연결된 업체가 사용 중이 아님' };
export default function RecordsHintLinkModal(props) {
  var jobKind = props.jobKind, showToast = props.showToast;
  var [pv, setPv] = useState(null);
  var [err, setErr] = useState('');
  var [changed, setChanged] = useState(false);
  var [busy, setBusy] = useState(false);
  useEffect(function () {
    var alive = true;
    post('/work-records/link-hints', { jobKind: jobKind, dryRun: true }).then(function (res) {
      if (!alive) return;
      if (res.data.success) setPv(res.data); else setErr(res.data.error || '미리보기를 만들지 못했습니다');
    }).catch(function () { if (alive) setErr('서버 오류'); });
    return function () { alive = false; };
  }, [jobKind]);
  var run = function () {
    if (busy || !pv) return;
    setBusy(true);
    post('/work-records/link-hints', { jobKind: jobKind, expect: { linkable: pv.linkable, amount: pv.amount } }).then(function (res) {
      setBusy(false);
      var d = res.data;
      if (res.status === 409 && d.code === 'PREVIEW_CHANGED') { setPv(d.preview || null); setChanged(true); return; }
      if (!d.success) { showToast(d.error || '연결 실패', 'err'); return; }
      showToast((d.updated || 0) + '건을 참고 업체로 연결했습니다');
      props.onDone();
    }).catch(function () { setBusy(false); showToast('서버 오류', 'err'); });
  };
  var un = (pv && pv.unresolved) || {};
  var unKeys = Object.keys(un).filter(function (k) { return num(un[k]) > 0; });
  return (<div style={overlay} onClick={function () { if (!busy) props.onClose(); }}>
    <div role="dialog" aria-label="참고 업체로 일괄 연결" onClick={function (e) { e.stopPropagation(); }}
      style={{ background: '#fff', borderRadius: 12, padding: 20, width: 480, maxWidth: '94vw', maxHeight: '90vh', overflowY: 'auto' }}>
      <h3 style={{ margin: '0 0 4px', fontSize: 16, fontWeight: 700 }}>참고 업체로 일괄 연결</h3>
      <p style={hintSt}>미연결 입금 중 엑셀 참고 거래처가 한 업체로 정해지는 건을 그 업체에 연결합니다.</p>
      {changed && <div style={{ marginBottom: 8, padding: '8px 10px', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, fontSize: 12.5, color: '#92400e' }}>그 사이 기록이 바뀌어 미리보기를 새로 만들었습니다. 확인 후 다시 연결해 주세요.</div>}
      {errBox(err)}
      {!pv && !err && <div style={{ padding: 16, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>미리보기 만드는 중…</div>}
      {!!pv && <div>
        <div style={{ fontSize: 13.5, fontWeight: 800, color: '#1B3A5C', marginBottom: 6 }}>연결할 입금 {fmt(pv.linkable)}건 · {fmt(pv.amount)}원</div>
        {(pv.byUnit || []).length > 0 && <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e2e8f0' }}>
          <thead><tr><th style={th}>업체</th><th style={Object.assign({}, th, { textAlign: 'right' })}>건수</th><th style={Object.assign({}, th, { textAlign: 'right' })}>금액</th></tr></thead>
          <tbody>{pv.byUnit.map(function (u) {
            return <tr key={u.unitId} data-testid="hint-unit"><td style={td}>{u.unitName}</td><td style={Object.assign({}, td, { textAlign: 'right' })}>{fmt(u.count)}</td><td style={Object.assign({}, td, { textAlign: 'right' })}>{fmt(u.amount)}</td></tr>;
          })}</tbody>
        </table>}
        {!num(pv.linkable) && <div style={{ fontSize: 12.5, color: '#64748b' }}>지금 참고 업체로 연결할 입금이 없습니다.</div>}
        {unKeys.length > 0 && <div style={{ marginTop: 10, fontSize: 12, color: '#64748b', lineHeight: 1.6 }}>
          <div style={{ fontWeight: 700, color: '#475569' }}>그대로 두는 입금 — 입금 목록에서 직접 연결할 수 있습니다</div>
          {unKeys.map(function (k) { return <div key={k}>{UNRESOLVED_LABEL[k] || k} {fmt(un[k])}건</div>; })}
        </div>}
      </div>}
      <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
        <button className="btn btn-outline" style={{ flex: 1, justifyContent: 'center' }} disabled={busy} onClick={props.onClose}>닫기</button>
        <button className="btn btn-blue" style={Object.assign({ flex: 1, justifyContent: 'center' }, (busy || !pv || !num(pv.linkable)) ? { opacity: 0.45, cursor: 'not-allowed' } : null)} disabled={busy || !pv || !num(pv.linkable)} onClick={run}>{busy ? '연결 중…' : '연결'}</button>
      </div>
    </div>
  </div>);
}
